import { api } from '../api/client';
import { ARTICLES, FEED } from '../api/endpoints';

export const contentService = {
  feed: (limit = 20) => api.get(FEED.LIST(limit)),
  article: (id) => api.get(ARTICLES.BY_ID(id)),
  view: (id, body = {}) => api.post(ARTICLES.VIEW(id), body),
  like: (id) => api.post(ARTICLES.LIKE(id)),
  share: (id) => api.post(ARTICLES.SHARE(id)),
  react: (id, reaction) =>
    api.post(ARTICLES.REACTIONS(id), { reaction: reaction ?? null }),
  comment: (id, text) => api.post(ARTICLES.COMMENTS(id), { text }),
  deleteComment: (articleId, commentId) =>
    api.delete(ARTICLES.DELETE_COMMENT(articleId, commentId)),
  listAdmin: (status) => api.get(ARTICLES.ADMIN_LIST(status)),
  getAdmin: (id) => api.get(ARTICLES.ADMIN_BY_ID(id)),
  create: (body) => api.post(ARTICLES.ADMIN_CREATE, body),
  update: (id, body) => api.patch(ARTICLES.ADMIN_BY_ID(id), body),
  submit: (id) => api.post(ARTICLES.SUBMIT(id)),
  approve: (id) => api.post(ARTICLES.APPROVE(id)),
  reject: (id, note) => api.post(ARTICLES.REJECT(id), { note }),
  publish: (id) => api.post(ARTICLES.PUBLISH(id)),
  unpublish: (id) => api.post(ARTICLES.UNPUBLISH(id)),
  remove: (id) => api.delete(ARTICLES.ADMIN_BY_ID(id)),
};
